import React from 'react'
import ProductsWithExpirationsHeader from './ProductsWithExpirationsHeader'
import ProductsWithExpirationsInner from './ProductsWithExpirationsInner'
import ProductsWithExpirationsFooter from './ProductsWithExpirationsFooter'
import { getWarehouses, getProductsInventory } from '../../../../ReportsFunctions'

export const productsWithExpirationsControllerContext = React.createContext()

function useProductsWithExpirationsController(props) {
  return ({
    filter: props.filter,
    getWarehouses,
    getProductsInventory
  })
}

function ProductsWithExpirationsController(props) {
  const productsWithExpirationsController = useProductsWithExpirationsController(props)
  return (
    <React.Fragment>
      <productsWithExpirationsControllerContext.Provider value={productsWithExpirationsController}>
        <ProductsWithExpirationsHeader />
        <ProductsWithExpirationsInner />
        <ProductsWithExpirationsFooter />
      </productsWithExpirationsControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ProductsWithExpirationsController)